import { beam } from '@styles/colors/themes';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafbfd;
`;

export const LogoHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;
export const Body = styled.div`
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 8px 26px rgba(0, 0, 0, 0.12);
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 464px;
  max-height: 350px;
  width: 100%;
`;

export const Button = styled.button`
  background: #1371fe;
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  text-align: center;
  padding: 8px;
`;

export const Description = styled.div`
  width: 100%;
  text-align: center;

  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  /* or 157% */

  /* Neutral/N800 (Text Normal) */
  color: ${beam.font.neutral};
`;

export const Email = styled.div`
  width: 100%;
  text-align: center;
  color: #000;
  font-size: 16px;
  font-weight: 600;
`;

export const Name = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
`;

export const TitleResult = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  color: ${beam.font.black};

  flex: none;
  order: 0;
  flex-grow: 0;
`;

export const StyledImg = styled.img`
  width: 40px;
  height: 40px;
`;
export const LogoImg = styled.img`
  width: 60px;
  height: 16px;
`;
